const yesNoOptions = [
  {
    value: true,
    option: "Yes",
  },
  {
    value: false,
    option: "No",
  },
];

const riskOptions = [
  {
    value: "pending",
    option: "Pending",
  },
  {
    value: "highRisk",
    option: "High Risk",
  },
  {
    value: "lowRisk",
    option: "Low Risk",
  },
];

const smartSearchAmlResults = [
  {
    value: "pending",
    option: "Pending",
  },
  {
    value: "highRisk",
    option: "High Risk",
  },
  {
    value: "lowRisk",
    option: "Low Risk",
  },
  {
    value: "refer",
    option: "Refer",
  },
];

const genericConfig = { yesNoOptions, riskOptions, smartSearchAmlResults };
export default genericConfig;
